import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton, Paper } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type AlertDialogProps = {
    open?: boolean; // Controls the initial open state
    onClose?: () => void; // Callback for when the element is "closed"
    backgroundColor?: string;
};

const PHIAlert: React.FC<AlertDialogProps> = ({
    open = true, // Default to true if not provided
    onClose,
    backgroundColor = '#fff',
}) => {
    const [isVisible, setIsVisible] = useState<boolean>(open);

    useEffect(() => {
        setIsVisible(open);
    }, [open]);

    const handleClose = () => {
        setIsVisible(false);
        if (onClose) {
            onClose();
        }
    };

    if (!isVisible) {
        return null; // Don't render anything if not visible
    }

    return (
        <Paper
            elevation={4} // Adds a shadow to resemble a dialog
            sx={{
                backgroundColor,
                maxWidth: '80%',
                minWidth: '600px',
                position: 'absolute',
                top: '86%',
                left: '50%',
                transform: 'translate(-50%, -86%)',
                margin: 0,
                zIndex: 1000,
                pointerEvents: 'auto',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: 1.5,
                overflow: 'hidden',
            }}
        >
            <Box
                sx={{
                    padding: 2,
                    fontWeight: 'bold',
                    position: 'relative',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                }}
            >
                <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                    {'CAUTION: Unauthorized or improper access or use of this system is strictly prohibited.'}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
            <Box sx={{ padding: 2, flexGrow: 1, overflowY: 'auto' }}>
                <Typography variant="body1" gutterBottom>
                    {'This system may be used to access Protected Health Information ("PHI") or Personally Identifiable Information '
                    + '("PII") governed by, among others, the Health Insurance Portability and Accountability Act ("HIPAA"), '
                    + 'the Health Information Technology for Economic and Clinical Health Act ("HITECH"). '
                    + 'By logging in and/or using this system, you agree to abide by all applicable law, as well as the terms and '
                    + 'limitations of any contracts, policies, and procedures to which you are subject. Breach of this trust is a '
                    + 'serious violation that may subject you to criminal and civil penalties, as well as disciplinary actions, up '
                    + 'to and including termination of employment.'}
                </Typography>
            </Box>
        </Paper>
    );
};

export default PHIAlert;